<template lang="pug">
.footer-menu
  ul.footer-menu__list
    li.footer-menu__link(
      v-for="link in links"
      :key="link.id"
      @click="scrollToSection(link.id)"
    ) {{ link.name }}
</template>

<script>
import { scrollTo } from '@/modules/UserEventLanding/functions';

export default {
  name: 'FooterMenu',

  props: {
    links: { type: Array, default: () => [] },
  },

  methods: {
    scrollToSection(id) {
      scrollTo(`#${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-menu {

  &__title {
    color: #{$redesignControlsBackground};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 380px;
    margin-top: 20px;
    padding: 0;
    list-style: none;
  }

  &__link {
    color: #{$redesignPrimaryLighten};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    cursor: pointer;
    transition: color .2s;

    &:hover {
      color: #{$redesignControlsBackground};
    }
  }
}
</style>
